<template>
    <div class="container h-full">
        <div class="overflow-hidden rounded-md">
            <div class="px-4 py-5 space-y-6 bg-white">
                <form
                    class="px-1"
                    @submit.prevent="submitForm"
                >
                    <div class="mt-4">
                        <JetLabel
                            for="name"
                            value="Name"
                        />
                        <JetInput
                            id="name"
                            v-model="form.name"
                            type="text"
                            class="block w-full mt-1"
                            required
                            autofocus
                            autocomplete="name"
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="email"
                            value="Email"
                        />
                        <JetInput
                            id="email"
                            v-model="form.email"
                            type="email"
                            class="block w-full mt-1"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="phone"
                            value="Phone"
                        />
                        <JetInput
                            id="phone"
                            v-model="form.phone"
                            type="text"
                            class="block w-full mt-1"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="address"
                            value="Address"
                        />
                        <JetInput
                            id="address"
                            v-model="form.address"
                            type="text"
                            class="block w-full mt-1"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="idNo"
                            value="Id No"
                        />
                        <JetInput
                            id="idNo"
                            v-model="form.idNo"
                            type="text"
                            class="block w-full mt-1"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="basicSalary"
                            value="Basic Salary"
                        />
                        <JetInputPrefix
                            id="basicSalary"
                            v-model="form.basicSalary"
                            placeholder="Salary"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="commission"
                            value="Commission"
                        />
                        <!-- <JetInput
                            id="commission"
                            v-model="form.commission"
                            type="text"
                            class="block w-full mt-1"
                            required
                        /> -->
                        <JetInputSuffix
                            id="commission"
                            v-model="form.commission"
                            suffix="%"
                            placeholder="Commission"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="thresholdSale"
                            value="Threshold Sale"
                        />
                        <JetInput
                            id="thresholdSale"
                            v-model="form.thresholdSale"
                            type="text"
                            class="block w-full mt-1"
                            required
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="password"
                            value="Password"
                        />
                        <JetInput
                            id="password"
                            v-model="form.password"
                            type="password"
                            class="block w-full mt-1"
                            required
                            autocomplete="new-password"
                        />
                    </div>

                    <div class="mt-4">
                        <JetLabel
                            for="password_confirmation"
                            value="Confirm Password"
                        />
                        <JetInput
                            id="password_confirmation"
                            v-model="form.password_confirmation"
                            type="password"
                            class="block w-full mt-1"
                            required
                            autocomplete="new-password"
                        />
                    </div>

                    <div class="flex items-center justify-end gap-2 mt-4">
                        <JetButton
                            :class="{ 'opacity-25': form.processing }"
                            :disabled="form.processing"
                        >
                            Save
                        </JetButton>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import JetButton from '../Jetstream/Button.vue';
import JetInput from '../Jetstream/Input.vue';
import JetInputPrefix from '../Jetstream/InputPrefix.vue';
import JetInputSuffix from '../Jetstream/InputSuffix.vue';
import JetLabel from '../Jetstream/Label.vue';

export default {
    name: 'ConfigAdmin',

    components: {
        JetButton,
        JetInput,
        JetInputPrefix,
        JetInputSuffix,
        JetLabel,
    },

    data() {
        return {
            form: this.$inertia.form({
                name: null,
                email: null,
                password: null,
                password_confirmation: null,
                phone: null,
                address: null,
                idNo: null,
                basicSalary: null,
                commission: null,
                thresholdSale: null,
            }),
        };
    },

    methods: {
        submitForm() {
            this.form.post(route('users.management.salesperson.create'), {
                onSuccess: () => { this.$emit('transactionComplete'); },
            });
        },
    },
};
</script>
